















































































































































































































































































































































































import ISells from "@/store/models/ISells";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import IRolePermission from "@/store/models/IRolePermission";
import ICompany from "@/store/models/ICompany";
import ICustomer from "@/store/models/ICustomer";
import IListStatusSell from "@/store/models/IListStatusSell";
import Snackbar from "@/components/shared/Snackbar.vue";
import moment from "moment";
import IStock from "@/store/models/IStock";
import { SettingsCompany } from "@/components/shared/SettingsCompany";
import IAuthentication from "@/store/models/IAuthentication";
import ISettingsCompany from "@/store/models/ISettingsCompany";
import SettingsCompanyApi from "@/store/api/SettingsCompanyApi";

@Component({
    components: {
        Snackbar
    }
})
export default class SellsSelector extends Vue {
  searchSell: string = "";
  dialog: boolean = false;
  dialogStatus: boolean = false;
  isValid: boolean = true;
  isValidStatus: boolean = true;
  notificationText: string = "";

  sortBy: string = "dateSell";
  sortDesc: boolean = true;
  showCompletedSells: boolean = false;

  menuDateSell: boolean = false;

  headers: any = [
      { text: "Company Source", align: "start", value: "companySourceName" },
      { text: "Company Destination", value: "companyDestinationName" },
      { text: "Customer Source Name", value: "customerSourceName" },
      { text: "Customer Destination Name", value: "customerDestinationName" },
      { text: "Dossier Number Source", value: "inboundCodeSource" },
      { text: "Dossier Number Destination", value: "inboundCodeDestination" },
      { text: "Date Sell", value: "dateSell" },
      { text: "Order Number", value: "orderNumber" },
      { text: "Status", value: "statusName" },
      { text: "Actions", value: "actions", sortable: false }
  ];

  editedIndex: number = -1;

  editedItem: ISells = {
      id: "",
      idCustomerSource: "",
      customerSourceName: "",
      idCustomerDestination: "",
      customerDestinationName: "",
      dateSell: new Date(),
      inboundCodeDestination: "",
      idCompanySource: "",
      companySourceName: "",
      idCompanyDestination: "",
      companyDestinationName: "",
      idListStatusSell: "",
      statusName: "",
      description: "",
      inboundCodeSource: "",
      orderNumber: ""
  };

  defaultItem: ISells = {
      id: "",
      idCustomerSource: "",
      customerSourceName: "",
      idCustomerDestination: "",
      customerDestinationName: "",
      dateSell: new Date(),
      inboundCodeDestination: "",
      idCompanySource: "",
      companySourceName: "",
      idCompanyDestination: "",
      companyDestinationName: "",
      idListStatusSell: "",
      statusName: "",
      description: "",
      inboundCodeSource: "",
      orderNumber: ""
  };

  @Prop({ type: Array, required: true })
  SellList!: ISells[];

  @Prop({ type: Array, required: true })
  Permissions!: IRolePermission[];

  @Prop({ type: Array, required: true })
  CompanyList!: ICompany[];

  @Prop({ type: Array, required: true })
  CustomerList!: ICustomer[];

  @Prop({ type: Array, required: true })
  StatusSellList!: IListStatusSell[];

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  @Prop()
  UserName!: string;

  @Prop()
  value!: ISells;

  @Prop({ type: Array, required: true })
  InboundsCodeList!: IStock[];

  @Prop({ type: Boolean, default: false })
  HasDetails!: boolean;

  @Prop()
  CompanyId!: string;

  @Prop({ type: Boolean, default: false })
  IsStandAlone!: boolean;

  selectedSell: ISells[] = [];
  selectedCompanySource: ICompany = {} as ICompany;
  selectedCompanyDestination: ICompany = {} as ICompany;
  selectedCustomerSource: ICustomer = {} as ICustomer;
  selectedCustomerDestination: ICustomer = {} as ICustomer;
  selectedStatusSell: IListStatusSell | null = null;
  selectedInboundCodeSource: IStock = {} as IStock;

  // v-date-picker model (yyyy-mm-dd)
  dateSell: string = (new Date(Date.now() - new Date().getTimezoneOffset() * 60000))
  .toISOString()
  .substr(0, 10);

  // legacy / unused but keeping as in original
  menu2: boolean = false;

  settingsCompanyApi: SettingsCompanyApi;

  // status snapshot + pending notification
  originalStatusId: string = "";
  originalStatusName: string = "";
  pendingNotificationText: string = "";

  constructor() {
      super();
      this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
  }

  // --------------------------
  // Date rule: min = inbound.dateIn
  // --------------------------
  get hasInboundDate(): boolean {
      return !!(this.selectedInboundCodeSource && (this.selectedInboundCodeSource as any).dateIn);
  }

  private toISODate(d: Date): string {
      return (new Date(d.getTime() - new Date().getTimezoneOffset() * 60000))
      .toISOString()
      .substr(0, 10);
  }

  get inboundDateInISO(): string {
      if (!this.hasInboundDate) {
      // fallback (won't be used if disabled)
          return this.toISODate(new Date());
      }
      const inboundDate = new Date((this.selectedInboundCodeSource as any).dateIn);
      return this.toISODate(inboundDate);
  }

  get minDateSellForPicker(): string {
      return this.inboundDateInISO;
  }

  get DateSellFormatted(): string {
      return this.formatDate(this.dateSell) || "";
  }

  set DateSellFormatted(value: string) {
      const parsed = this.parseDate(value);
      if (parsed) this.dateSell = parsed;
  }

  // --------------------------
  // Status helpers
  // --------------------------
  get isCurrentStatusExternal(): boolean {
      if (this.editedIndex === -1) return false;
      if (!this.editedItem || !this.editedItem.idListStatusSell) return false;
      if (!this.StatusSellList || this.StatusSellList.length === 0) return true;

      const exists = this.StatusSellList.some((s) => s.id === this.editedItem.idListStatusSell);
      return !exists;
  }

  get currentStatusHint(): string {
      if (this.isCurrentStatusExternal) {
          return "This status was set by another company. You can still change it to one of your company statuses.";
      }
      return "This is the current status. You can change it to another status defined in your company.";
  }

  get CompanySource() {
      const index = this.CompanyList.findIndex((c) => c.id === this.CompanyId);
      return index !== -1 ? [this.CompanyList[index]] : [];
  }

  formatDate(date: string) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
  }

  parseDate(date: string) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  get formTitle() {
      return this.editedIndex === -1 ? "New Sell" : "Edit Sell";
  }

  get customersFiltered(): ICustomer[] {
      return this.CustomerList.filter((c) => c.idCompany === this.selectedCompanySource.id) as ICustomer[];
  }

  // ✅ status seleccionable SOLO si el idListStatusSell existe en StatusSellList (mi empresa)
  get isStatusSelectable(): boolean {
      if (this.editedIndex === -1) return false;
      if (!this.editedItem || !this.editedItem.idListStatusSell) return false;
      if (!this.StatusSellList || this.StatusSellList.length === 0) return false;
      return this.StatusSellList.some((s) => s.id === this.editedItem.idListStatusSell);
  }

  // --------------------------
  // Watchers
  // --------------------------
  @Watch("dialog")
  onDialogChanged(val: any) {
      val || this.close();
  }

  @Watch("showCompletedSells")
  onChangeShowCompletedSells() {
      this.$emit("showCompletedSells", this.showCompletedSells);
  }

  @Watch("value")
  updateSelection(newValue: ISells | null) {
      if (!newValue || Object.keys(newValue).length === 0) {
          this.selectedSell = [];
      } else {
          this.selectedSell = [newValue];
          this.$emit("sellChanged", this.selectedSell[0]);
      }
  }

  @Watch("selectedCustomerSource")
  onChangeSelectedCustomerSource() {
      this.$emit("onChangeSelectedCustomerSource", this.selectedCustomerSource);
  }

  // ✅ Solo abrir dialog de notificación si el status es seleccionable y válido
  @Watch("selectedStatusSell")
  onChangeStatusInbound() {
      if (!this.selectedStatusSell || !this.selectedStatusSell.id) return;

      const newName = (this.selectedStatusSell.name || "").toLowerCase();
      const oldName = (this.editedItem.statusName || "").toLowerCase();

      if (newName !== "pending" && newName !== oldName) {
          this.notificationText = "";
          this.dialogStatus = true;
      }
  }

  @Watch("InboundsCodeList")
  onChangeInboundCodeList() {
      if (this.selectedInboundCodeSource === undefined) {
          if (this.selectedSell.length > 0) {
              this.selectedInboundCodeSource = this.InboundsCodeList.find(
                  (i: any) => i.codeInbounds === this.selectedSell[0].inboundCodeSource
              ) as IStock;
          }
      }
  }

  // ✅ Guardrail: when inbound changes, ensure dateSell >= inbound.dateIn
  @Watch("selectedInboundCodeSource", { deep: true })
  onChangeSelectedInboundCodeSource() {
      if (!this.hasInboundDate) return;

      const min = this.inboundDateInISO;
      if (!this.dateSell || this.dateSell < min) {
          this.dateSell = min;
      }
  }

  // --------------------------
  // Status apply helper
  // --------------------------
  private applyStatusIfValid() {
      if (!this.selectedStatusSell || !this.selectedStatusSell.id) return;

      const exists =
      this.StatusSellList && this.StatusSellList.some((s) => s.id === this.selectedStatusSell!.id);
      if (!exists) return;

      this.editedItem.idListStatusSell = this.selectedStatusSell.id;
      this.editedItem.statusName = this.selectedStatusSell.name;
  }

  // --------------------------
  // Notification dialog
  // --------------------------
  saveNotification() {
      if (!this.selectedSell || this.selectedSell.length === 0) {
          this.closeDialogStatus();
          return;
      }

      if (!this.selectedStatusSell || !this.selectedStatusSell.id) {
          this.closeDialogStatus();
          return;
      }

      let msg = "";
      if (this.notificationText === "") {
          msg =
        "\n" +
        "The user " +
        this.UserName +
        " has changed the sell " +
        this.selectedSell[0].inboundCodeDestination +
        " to status " +
        this.selectedStatusSell.name;
      } else {
          msg =
        "\n" +
        "The user " +
        this.UserName +
        " has changed the sell " +
        this.selectedSell[0].inboundCodeDestination +
        " to status " +
        this.selectedStatusSell.name +
        " Comment: " +
        this.notificationText;
      }

      // ✅ Guardamos el texto como “pendiente” para que el PADRE lo envíe SOLO si el UpdateSell va OK
      this.pendingNotificationText = msg;

      // ✅ lo añadimos al log del sell para guardarlo en BD
      this.editedItem.description += msg;

      this.closeDialogStatus();
  }

  // --------------------------
  // CRUD actions
  // --------------------------
  ResetSell() {
      this.selectedSell = [];

      if (this.IsStandAlone) {
          const index: number = this.CompanyList.findIndex((c) => c.id === this.CompanyId);
          if (index !== -1) {
              this.selectedCompanySource = this.CompanyList[index];
              this.selectedCompanyDestination = this.CompanyList[index];
          }
      } else {
          this.selectedCompanySource = {} as ICompany;
          this.selectedCompanyDestination = {} as ICompany;
      }

      this.selectedCustomerSource = {} as ICustomer;
      this.selectedCustomerDestination = {} as ICustomer;
      this.selectedInboundCodeSource = {} as IStock;

      // default date: today (will be corrected when inbound is selected)
      this.dateSell = new Date().toISOString().substring(0, 10);

      this.selectedStatusSell = this.StatusSellList.find((c) => c.name === "Pending") as IListStatusSell;

      this.$emit("resetSell");
  }

  editSell(item: any, dbox = true) {
      if (this.selectedSell.length > 0) {
          this.editedIndex = this.SellList.indexOf(item);

          this.selectedCustomerSource = this.CustomerList.find((c) => c.id === item.idCustomerSource) as ICustomer;
          this.selectedCustomerDestination = this.CustomerList.find(
              (c) => c.id === item.idCustomerDestination
          ) as ICustomer;

          this.selectedCompanySource = this.CompanyList.find((c) => c.id === item.idCompanySource) as ICompany;
          this.selectedCompanyDestination = this.CompanyList.find((c) => c.id === item.idCompanyDestination) as ICompany;

          this.selectedInboundCodeSource = this.InboundsCodeList.find(
              (i: any) => i.codeInbounds === item.inboundCodeSource
          ) as IStock;

          this.editedItem = Object.assign({}, item);
          this.dateSell = moment(new Date(item.dateSell)).format("YYYY-MM-DD");

          // ✅ Snapshot del status real (para poder revertir UI si el padre rechaza)
          this.originalStatusId = item.idListStatusSell;
          this.originalStatusName = item.statusName;

          // ✅ Selector: solo status local (si el status actual es externo -> queda vacío)
          const localStatus = this.StatusSellList.find((s) => s.id === item.idListStatusSell);
          this.selectedStatusSell = localStatus || null;

          // ✅ Guardrail for edit too: if somehow dateSell < inboundDateIn, fix it
          if (this.hasInboundDate) {
              const min = this.inboundDateInISO;
              if (this.dateSell < min) {
                  this.dateSell = min;
              }
          }

          this.dialog = true;
          this.dialogStatus = false;
      }
  }

  ToDateFormat(date: string): string {
      if (date === "" || date === null) return "";
      return moment(new Date(date)).format("DD-MM-YYYY");
  }

  async saveSell(_: ISells) {
      const formOk = (this.$refs.form as Vue & { validate: () => boolean }).validate();
      if (!formOk) {
          this.$emit("showMessageWarning", "All required fields must be filled out");
          return;
      }

      if (this.selectedCustomerSource.id === this.selectedCustomerDestination.id) {
          this.$emit(
              "showMessageWarning",
              "It is not possible to sell material to the same customer. Please select another customer destination."
          );
          return;
      }

      if (!this.selectedInboundCodeSource || (this.selectedInboundCodeSource as any).codeInbounds === undefined) {
          this.$emit("showMessageWarning", "Dossier Number source is required");
          return;
      }

      // ✅ Hard rule: cannot sell before inbound dateIn
      if (!this.hasInboundDate) {
          this.$emit("showMessageWarning", "Select a Dossier Number Source with a valid DateIn before choosing Date Sell.");
          return;
      }
      const min = this.inboundDateInISO;
      if (this.dateSell < min) {
          this.$emit("showMessageWarning", `Date Sell cannot be before the inbound DateIn (${this.formatDate(min)}).`);
          return;
      }

      let canSave = true;

      if (this.editedItem.inboundCodeDestination === "") {
          const userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem("user") || "{}");
          const settingsCompany = SettingsCompany.Settings.GenerateCode;
          const setting: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(
              userFromStorage.idCompany,
              settingsCompany
          );
          canSave = setting.length >= 1;
      }

      if (!canSave) return;

      // map campos normales
      this.editedItem.idCompanySource = this.selectedCompanySource.id;
      this.editedItem.idCompanyDestination = this.selectedCompanyDestination.id;
      this.editedItem.companySourceName = this.selectedCompanySource.name;
      this.editedItem.companyDestinationName = this.selectedCompanyDestination.name;

      this.editedItem.idCustomerSource = this.selectedCustomerSource.id;
      this.editedItem.customerSourceName = this.selectedCustomerSource.name;

      this.editedItem.idCustomerDestination = this.selectedCustomerDestination.id;
      this.editedItem.customerDestinationName = this.selectedCustomerDestination.name;

      this.editedItem.inboundCodeSource = (this.selectedInboundCodeSource as any).codeInbounds;
      this.editedItem.dateSell = new Date(this.dateSell);

      // ✅ status: SOLO si es local y válido. Si no, NO tocar status (mantener el del item).
      this.applyStatusIfValid();

      if (this.editedIndex > -1) {
          const notificationToSend = this.pendingNotificationText;

          this.$emit(
              "editSell",
              this.editedItem,
              (r: { success: boolean; sell?: ISells }) => {
                  if (r && r.success) {
                      this.pendingNotificationText = "";
                      this.close();
                      return;
                  }

                  // ❌ Rechazado: revertir UI
                  const fixedSell = r && r.sell ? r.sell : null;

                  if (fixedSell) {
                      this.editedItem = Object.assign({}, fixedSell);
                      this.originalStatusId = fixedSell.idListStatusSell;
                      this.originalStatusName = fixedSell.statusName;

                      // sync dateSell string
                      this.dateSell = moment(new Date(fixedSell.dateSell)).format("YYYY-MM-DD");
                  } else {
                      this.editedItem.idListStatusSell = this.originalStatusId;
                      this.editedItem.statusName = this.originalStatusName;
                  }

                  this.selectedStatusSell = null as any;
                  this.pendingNotificationText = "";
                  this.dialogStatus = false;
                  this.notificationText = "";
              },
              notificationToSend
          );

          return;
      }

      // NEW SELL: require status
      if (!this.selectedStatusSell || !this.selectedStatusSell.id) {
          this.$emit("showMessageWarning", "Status is required");
          return;
      }

      this.editedItem.idListStatusSell = this.selectedStatusSell.id;
      this.editedItem.statusName = this.selectedStatusSell.name;

      this.$emit("saveSell", this.editedItem);
      this.close();
  }

  deleteSell(sell: ISells) {
      if (this.selectedSell.length > 0) {
          this.$emit("deleteSell", sell);
          this.close();
      }
  }

  close(): void {
      this.dialog = false;
      this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
      });
  }

  closeDialogStatus(): void {
      this.dialogStatus = false;
      this.$nextTick(() => {
          this.notificationText = "";
      });
  }

  select(item: ISells): void {
      const index: number = this.selectedSell.findIndex((w) => w.id === item.id);
      if (index === -1) {
          this.selectedSell = [item];
          this.$emit("input", item);
      } else {
          const inbound = this.selectedSell.find((w) => w.id === item.id);
          if (!inbound) {
              this.selectedSell = [];
              this.$emit("input", null);
          }
      }
  }

  showMessageInfo(message: string) {
      (this.$refs.snackbar as Snackbar).showInfo(message);
  }

  showMessageError(message: string) {
      (this.$refs.snackbar as Snackbar).showError(message);
  }

  showMessageWarning(message: string) {
      (this.$refs.snackbar as Snackbar).showWarning(message);
  }
}
